<script>
    import CourseContactPromotionContainer from './CourseContactPromotionContainer'
    import OrangopackCard from './OrangopackCard'
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: ['course', 'items', 'courses'],
        components: {CourseContactPromotionContainer,OrangopackCard},
        data() {
            return {
                data: null,
                randomPlaces: null,
                isMobile: window.isMobile(),
                promotions: this.items,
                fetch: new Form({}),
                form: new Form({
                    type: 'App\\CoursePromotion',
                    buyable: {},
                    promotion_id: null
                }),
                invitationForm: new Form({
                    current_id: null,
                    company_id: null,
                    latitude: 0,
                    longitude: 0,
                    sport_id: null
                }),
                modalOptions: {
                    show: false,
                    backdrop: 'static',
                    keyboard: false
                },
                timeAlertPromotion: false,
                currentTab: 'description',
            }
        },
        computed: {
            activePromotions() {
                return this.items.filter(i => i.is_active).sort(function (a,b){
                    return a.price - b.price;
                })
            },
            minPromotion() {
                if (this.activePromotions.length > 0) {
                    return _.minBy(this.activePromotions, i => i.price)
                }
                return null
            },
            selectedPromotion() {
                if (_.isNumber(this.form.promotion_id)) {
                    return _.head(this.activePromotions.filter(i => i.id == this.form.promotion_id))
                }
                if (this.activePromotions.length > 0) {
                    return _.minBy(this.activePromotions, i => i.price)
                }
                return null
            }
        },
        watch: {
            'form.promotion_id': {
                handler(val) {
                    let promotion = _.head(this.items.filter(i => i.id == val))
                    this.$set(this.form, 'buyable', Object.assign(promotion, {
                        course: this.data
                    }))
                }
            }
        },
        mounted() {
            this.getCourse()
            this.setRandomPlaces(2, 9)
            $("#contactFormModal").modal(this.modalOptions)
            $("#notifyModal").modal(this.modalOptions)

            $("#contactFormModal").on('shown.bs.modal', () => {
                gtag('event', 'Form', {
                    'event_category': 'InvitiSport',
                    'event_label': '#contatta-societa_InvitiSport'
                });
            })

            $("#howToPromotionModal").on('shown.bs.modal', () => {
                gtag('event', 'Info', {
                    'event_category': 'InvitiSport',
                    'event_label': '#cose_InvitoSport'
                });
            })

            if (this.minPromotion) {
                this.$set(this.form, 'promotion_id', this.minPromotion.id)
            }

            setTimeout(() => {
                this.$set(this, 'timeAlertPromotion', true)
            }, 3000)

            window.onresize = () => {
                this.$set(this, 'isMobile', window.isMobile())
            }

            //this.getLocation();
        },
        methods: {
            getCourse() {
                this.fetch
                    .get(route('courses.packages', this.course))
                    .then(response => {
                        this.$set(this, 'data', response.course)

                        this.$set(this.invitationForm, 'current_id', this.data.id)
                        this.$set(this.invitationForm, 'company_id', this.data.company_id)
                        this.$set(this.invitationForm, 'sport_id', this.data.sport_id)
                    })
            },
            setRandomPlaces(min, max) {
                let random = Math.floor(Math.random() * (max - min + 1) + min)

                this.randomPlaces = random
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        this.returnPosition,
                        this.errorPosition
                    );
                }
            },
            returnPosition(position) {
                this.$set(this.invitationForm, 'latitude', position.coords.latitude * 1)
                this.$set(this.invitationForm, 'longitude', position.coords.longitude * 1)

                this.updateRelatedCourses();
            },
            errorPosition(error) {
                let {latitude, longitude} = this.invitationForm
                if (_.isEmpty(latitude) && _.isEmpty(latitude)) {
                    this.$set(this.invitationForm, 'latitude', 0)
                    this.$set(this.invitationForm, 'longitude', 0)

                    this.updateRelatedCourses();
                }
            },
            updateRelatedCourses() {
                this.invitationForm
                    .get(route('courses.related-invitation'))
                    .then(({courses}) => {
                        this.$set(this, 'courses', courses)
                        $(this.$refs.owl).trigger('refresh.owl.carousel')
                    })
            },
            beforeEnter(el) {
                el.style.height = '0'
            },
            editHeight(el) {
                el.style.height = `auto`
            },
            beforeLeave(el) {
                el.style.height = '0'
            },
            onSelectTab(tab) {
                if (!this.isMobile) {
                    return
                } else {
                    $("html,body").animate({
                        scrollTop: document.getElementById('myTabContent').offsetTop
                    })
                }

                if (this.currentTab == tab) {
                    this.$set(this, 'currentTab', null)
                } else {
                    this.$set(this, 'currentTab', tab)
                }
            },
            openTab(tab) {
                let offsetTop = 0

                $(`#myTabContent a[href="#${tab}"]`).tab('show')
                $(`#myTab a[href="#${tab}"]`).tab('show')

                if (this.isMobile) {
                    $(`#myTabContent a .tab-pane__collapse`).removeClass('active')
                    offsetTop = document.getElementById('myTabContent').offsetTop
                    $(`#myTabContent a[href="#${tab}"] .tab-pane__collapse`).addClass('active')
                } else {
                    offsetTop = document.getElementById('myTab').offsetTop
                }

                this.onSelectTab(tab)

                $("html,body").animate({ scrollTop: offsetTop })
            },
            getPromotionText(promotion) {
                if (_.isObject(promotion) && promotion) {
                    let lessons = promotion.lessons > 1 ? 'lezioni' : 'lezione'
                    let people = promotion.people > 1 ? 'persone' : 'persona'
                    let lessonType = promotion.lesson_type == 'group' ? 'di gruppo' : 'individuale'

                    return `${promotion.lessons} ${lessons} di ${this.data.sport.name} per ${promotion.people} ${people} a ${this.data.municipality}`
                }
            },
            onSubmitHeader(recordActivity = true) {
                if(recordActivity){
                    gtag('event', 'Cart', {
                        'event_category': 'OrangoPack',
                        'event_label': '#acquisto-sticy_op'
                    })
                };

                if (this.promotions.length > 1) {
                    var $target = $('.list-group-promotion');
                    $('html, body').animate({
                        scrollTop: $target.offset().top - 80
                    }, 1000);
                } else {
                    this.onSubmit(false)
                }
            },
            onSubmit(recordActivity = true) {
                if (recordActivity) {
                     gtag('event', 'Cart', {
                         'event_category': 'InvitiSport',
                         'event_label': '#aggiungi-carrello_main'
                     });
                }

                if (!this.form.promotion_id){
                    $('#promotion-error').removeClass('d-none');
                    $('#promotion-error-modal').removeClass('d-none');
                } else {
                    this.addToCart()
                }
            },
            addToCart() {
                this.form
                    .submit('post', route('cart.store'))
                    .then((response) => {
                        window.alerts.success('Elemento aggiunto al carrello');
                        window.location = '/carts'
                    })
            },
            promotionTotalPrice(promotion){
                let total = parseFloat(promotion.price);
                if(this.data.active_promotion_fee){
                    total += parseFloat(this.data.promo_membership_fee * promotion.people);
                }
                return total.toFixed(2)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CoursePromotionContainer.vue